<template>
  <main>
    <backbar
      :tit="$t('service.continueQuestionsToReply')"
      to="serviceH5OrderDetail"
      :param="this.work_order_id"
    ></backbar>

    <div class="container">
      <div class="remind">{{ $t("service.replyProblems") }}！</div>

      <div class="info_box">
        <h5>{{ $t("service.account") }}</h5>
        <p v-text="user_mid"></p>
      </div>

      <div class="info_box">
        <h5>{{ $t("service.game") }}</h5>
        <p v-text="game_name"></p>
      </div>

      <div class="info_box">
        <h5>{{ $t("service.questionsType") }}</h5>
        <p v-text="questionType[question_type]"></p>
      </div>

      <div class="info_box">
        <h5>{{ $t("service.roleId") }}</h5>
        <p v-text="character_id"></p>
      </div>

      <div class="info_box">
        <h5>{{ $t("service.roleName") }}</h5>
        <p v-text="character_name"></p>
      </div>

      <div class="info_box">
        <h5>{{ $t("service.email") }}</h5>
        <p v-text="email"></p>
      </div>

      <!-- <div class="info_box">
                <h5>設定Line Notify</h5>
                <p v-text="line_notify"></p>
            </div> -->

      <div class="info_box">
        <h5>{{ $t("service.questionsTitle") }}</h5>
        <p v-text="question_title"></p>
      </div>

      <div class="info_box">
        <h5 class="dark">{{ $t("service.questionsContent") }}</h5>
        <textarea
          v-model="question_content"
          :placeholder="$t('service.inputQuestionContentAdvice')"
          rows="10"
          @blur="vertify"
        ></textarea>
        <p class="info_err" v-text="question_content_err"></p>
      </div>

      <!-- <div class="info_box">
                <h5>檔案</h5>
                <div class="imgList">
                    <div class="imgBox" v-for="(i,n) in attachments" :key="n">
                        <img :src="i" alt="">
                    </div>
                </div>
            </div> -->

      <div class="info_box">
        <h5>{{ $t("service.choseRecord") }}</h5>
        <div class="imgInput">
          <div
            class="previewImg"
            v-for="(i, n) in attachments"
            :key="n"
            @click="imgView(n)"
            :style="{ backgroundImage: 'url(' + i + ')' }"
          >
            <!-- <img :src="i" alt=""> -->
          </div>
          <template v-for="i in [1, 2, 3]">
            <div class="file_btn" v-if="i > attachments.length" :key="i">
              <div
                class="loadingImg"
                v-if="i - attachments.length == 1 && loadingFlag"
              ></div>
              <input
                type="file"
                name="file"
                @click="onInputClick($event)"
                @change="uploadChange"
                accept="image/*"
              />
            </div>
          </template>
        </div>
        <div class="info">{{ $t("service.attachmentHint") }}。</div>
      </div>

      <div class="info_box">
        <h5>{{ $t("service.preReplyContent") }}</h5>

        <div class="replay_item" v-if="!cs_reply_list.length">
          <div class="re_top">
            <img src="../images/time.svg" alt="" />
            <span class="time" v-text="create_time"></span>
            <span class="status status_4">{{ $t("service.noReply") }}</span>
          </div>
        </div>

        <div class="replay_item" v-for="(i, n) in cs_reply_list" :key="n">
          <div class="re_top">
            <img src="../images/time.svg" alt="" />
            <span class="time" v-text="i.reply_time"></span>
            <span
              class="status"
              :class="'status_' + i.reply_status"
              v-text="statusType[i.reply_status]"
            ></span>
          </div>
          <div class="re_content" v-html="i.reply_content"></div>
        </div>
      </div>

      <div class="info_box btn_box">
        <router-link
          :to="{
            name: 'serviceH5OrderDetail',
            query: { id: this.work_order_id },
          }"
          class="inline_btn border_btn"
          ga-data="2402002"
          >{{ $t("service.cancel") }}
        </router-link>

        <a
          href="javascript:;"
          class="inline_btn fill_btn"
          @click="submitForm"
          ga-data="2402001"
          >{{ $t("service.sureSent") }}</a
        >
      </div>
    </div>

    <div class="imgPreview" :class="{ out: !showImg }">
      <div class="backbar">
        <div class="back_btn" @click="showImg = false">
          <img src="../images/back.svg" alt="" />
        </div>
        <span class="tit">{{ $t("service.lookRecord") }} </span>
        <span class="tit swiper-pg" slot="pagination"></span>

        <div class="del" @click="delImg">
          <img src="../images/delete.svg" alt="" />
        </div>
      </div>

      <swiper :options="swiperOption" ref="mySwiper">
        <!-- 这部分放你要渲染的那些内容 -->
        <swiper-slide v-for="(i, n) in attachments" :key="n">
          <div class="imgBox">
            <img class="swp_img" :src="i" alt="" />
          </div>
        </swiper-slide>
      </swiper>
    </div>

    <goTop></goTop>
    <h5-nav v-if="$region !== 'jp' "></h5-nav>
    <!-- <bottombar></bottombar> -->
  </main>
</template>

<script>
import Vue from "vue";
import h5Nav from "@/component/h5nav/komoe";
// import bottombar from '@/component/bottombar_h5/index.vue';
import backbar from "@commonBackbar";
// import popWindow from '@/component/popWindow/index.vue';
import goTop from "./component/goTop";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  name: "index",
  data() {
    return {
      work_order_id: this.$route.query.id,
      game_base_id: "",
      game_name: "",
      question_type: 1,
      create_time: "",
      character_id: "",
      character_name: "",
      email: "",
      // line_notify: 1,
      question_title: "",
      question_content: "",
      question_content_err: "",
      attachments: [],
      work_order_status: 1,
      grade: 2,
      source: "",
      cs_reply_list: [],
      questionType: {},
      statusType: {
        2: this.$t("service.processing"),
        3: this.$t("service.replied"),
        4: this.$t("service.closedCases"),
      },
      showImg: false,
      swiperOption: {
        notNextTick: true,
        pagination: {
          el: ".swiper-pg",
          type: "fraction",
        },
        slidesPerView: "auto",
        centeredSlides: true,
        paginationClickable: true,
        spaceBetween: 30,
      },
      user_mid: "",
      sendable: true,
      loadingFlag: false,
    };
  },
  components: {
    // bottombar,
    backbar,
    // popWindow,
    // newWordOrder,
    goTop,
    swiper,
    swiperSlide,
    h5Nav,
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  methods: {
    vertify() {
      // const contentMaxLength = this.globalLang === 'en' ? 2000 : 1000
      const contentMaxLength = 1000;
      if (this.question_content.length > contentMaxLength) {
        this.question_content_err = this.$t(
          "service.inputVaildQuestionContent"
        );
        return;
      }
      // 校验
      if (!this.question_content) {
        this.question_content_err = this.$t("service.inputQuestionContent");
        return false;
      } else {
        this.question_content_err = "";
        return true;
      }
    },
    submitForm() {
      if (!this.vertify() || !this.sendable || this.loadingFlag) {
        return;
      }

      this.sendable = false;
      // 提交表单
      this.$apis.service
        .newWordOrder(
          this.work_order_id,
          this.game_base_id,
          this.character_id,
          this.character_name,
          this.email,
          this.question_type,
          this.question_title,
          this.question_content,
          this.source,
          this.attachments,
          this.$utils.token("joy_jct")
        )
        .then((res) => {
          this.sendable = true;
          if (res.data.code == 0) {
            this.$router.push({
              name: "serviceH5OrderDetail",
              query: { id: res.data.data.work_order_id },
            });
          } else if (res.data.code == -10000) {
            alert(this.$t("service.noContinueQuestion"));
          } else {
            alert(
              this.$t(`serviceCode.${res.data.code}`) ||
                res.data.message ||
                this.$t("service.submitFail")
            );
          }
        })
        .catch(() => {
          this.sendable = true;
          alert(this.$t("service.networkException"));
        });
    },
    onInputClick(e) {
      if (this.loadingFlag || this.attachments.length === 3) {
        e.preventDefault();
        return;
      }
    },
    uploadChange(e) {
      let file = e.target.files[0];
      // console.log(file)

      let data = new FormData();
      data.append("file", file);
      data.append("size", file.size);
      if (!file.type || (file.type && file.type.indexOf("image") < 0)) {
        alert(this.$t("service.uploadRightFile"));
        return;
      }
      if (file.size / 1024 / 1024 > 5) {
        alert(this.$t("service.vaildRecordSize"));
        return;
      }
      this.loadingFlag = true;
      this.$apis.service
        .upload({ data: data, ct: this.$utils.token("joy_jct") })
        .then((res) => {
          this.loadingFlag = false;
          if (res.data.code == 0) {
            if (this.attachments.length <= 2) {
              this.attachments.push(res.data.data);
            }
          } else if (res.data.code == -1) {
            alert(this.$t("service.vaildRecordSize"));
          } else {
            alert(res.data.message || this.$t("service.uploadPicError"));
          }
        })
        .catch(() => {
          this.loadingFlag = false;
          alert(this.$t("service.networkRequestError"));
        });
    },
    imgView(i) {
      this.showImg = true;
      this.swiper.slideTo(i, 0);
    },
    delImg() {
      // console.log(this.swiper.activeIndex)
      this.attachments.splice(this.swiper.activeIndex, 1);
      if (this.attachments.length == 0) {
        this.showImg = false;
      }
    },
  },
  mounted: function() {
    // 获取问题类型列表
    this.$apis.service.commonQuestionTypeList().then((res) => {
      if (res.data.code == 0) {
        res.data.data.forEach((ele) => {
          // this.questionType[ele.question_type] = ele.question_type_desc
          Vue.set(this.questionType, ele.question_type, ele.question_type_desc);
        });
      }
    });

    // 判断用户设备
    let u = navigator.userAgent;
    let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
      this.source = "Android";
    } else if (isiOS) {
      this.source = "iOS";
    } else {
      this.source = "web";
    }

    this.$apis.service.getOrderDetail(this.work_order_id).then((res) => {
      // console.log(res)
      if (res.data.code == 0) {
        Object.assign(this, res.data.data);
        this.attachments = [];
        this.question_content = "";
        this.question_title = "RE:" + this.question_title;
      }
    });

    var ct = this.$utils.token("joy_jct");
    this.$apis.service.getConnectInfo(ct).then((res) => {
      if (res.data.code == 0) {
        this.user_mid = res.data.data.mid || "";
      }
    });
  },
};
</script>

<style lang="scss">
@import "../../scss/common_h5.scss";
@import "~swiper/dist/css/swiper.css";
</style>
<style lang="scss" scoped>
.info_box {
  margin: 0.2rem 0;

  h5 {
    font-size: 0.12rem;
    color: #bdbdbd;
    line-height: 0.16rem;
    margin: 0 0 0.1rem;
    font-weight: normal;

    &.dark {
      color: $cl_dark;
    }
  }

  p {
    margin: 0;
    font-size: 0.14rem;
    color: $cl_dark;
    line-height: 0.19rem;
  }

  .imgList {
    display: flex;
    justify-content: space-between;

    .imgBox {
      width: 1rem;
      height: 1rem;
      border: 1px solid #cccccc;
      border-radius: 0.2rem;
      overflow: hidden;

      img {
        display: block;
        width: 100%;
      }
    }
  }

  .replay_item {
    background: #f2f2f2;
    border-radius: 0.12rem;
    overflow: hidden;
    margin-bottom: 0.1rem;

    .re_top {
      box-sizing: border-box;
      height: 0.38rem;
      padding: 0.12rem;

      img {
        float: left;
        width: 0.1rem;
        height: 0.1rem;
        margin-right: 0.04rem;
      }

      .time {
        float: left;
        font-size: 0.1rem;
        color: #999999;
      }

      .status {
        font-size: 0.1rem;
        width: auto;
        height: 0.14rem;
        line-height: 0.14rem;
        border-radius: 0.07rem;
        text-align: center;
        float: right;
        color: #ffffff;
        padding: 0 0.05rem;

        &.status_2 {
          background: #ffa0a0;
        }

        &.status_3 {
          background: #8fd7c1;
        }

        &.status_4 {
          background: #999999;
        }
      }
    }

    .re_content {
      border-top: 1px solid #dddddd;
      padding: 0.12rem 0;
      margin: 0 0.12rem;
      line-height: 0.19rem;
      font-size: 0.14rem;
      color: $cl_dark;

      img {
        max-width: 100%;
      }
    }
  }

  textarea {
    background: #ffffff;
    border: 1px solid #cccccc;
    border-radius: 0.2rem;
    padding: 0.12rem;
    width: 3.36rem;
    font-size: 0.12rem;
    box-sizing: border-box;
    resize: none;

    &::-webkit-input-placeholder {
      color: #cccccc;
    }
  }

  .imgInput {
    display: flex;
    justify-content: space-between;

    .previewImg {
      position: relative;
      flex-shrink: 0;
      flex-grow: 0;
      height: 1rem;
      width: 1rem;
      overflow: hidden;
      border-radius: 0.2rem;
      background: #999999;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;

      img {
        display: block;
        width: 100%;
      }
    }

    .file_btn {
      position: relative;
      flex-shrink: 0;
      flex-grow: 0;
      height: 1rem;
      width: 1rem;
      overflow: hidden;
      background: url(../images/addpic.svg) center center no-repeat;
      background-size: contain;

      input {
        display: block;
        width: 100%;
        height: 100%;
        opacity: 0;
      }
    }

    .loadingImg {
      position: absolute;
      width: 1rem;
      height: 1rem;
      top: 0;
      left: 0;
      border-radius: 50%;
      background: #ffffff url(../images/loading_small.svg) center center
        no-repeat;
      background-size: 0.3rem 0.3rem;
      animation: roll 1s infinite;
    }
  }

  .info_err {
    text-align: center;
    font-size: 0.1rem;
    color: #ff5555;
    margin-top: 4px;
  }
}

.level_box {
  text-align: center;
  border-top: 1px solid #eeeeee;
  font-size: 0;
  padding: 0.3rem 0 0.2rem;

  h5 {
    font-size: 0.12rem;
    color: #999999;
  }
}

.star_box {
  .star_item {
    display: inline-block;
    height: 0.4rem;
    width: 0.4rem;
    background: url(../images/star_gray.svg) center center no-repeat;
    background-size: contain;
    margin-right: 0.2rem;

    &:last-child {
      margin-right: 0;
    }

    &.shine {
      background-image: url(../images/star_shine.svg);
    }
  }
}

.btn_box {
  .inline_btn {
    width: 1.62rem;
    margin: 0.2rem 0;

    &:first-child {
      margin-right: 0.12rem;
    }
  }
}

.postGrade {
  font-size: 0;
  text-align: center;

  h5 {
    font-size: 0.12rem;
    color: #cccccc;
    font-weight: normal;
  }
}

.imgPreview {
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #000000;
  transition: all 0.2s;

  &.out {
    top: 100vh;
    opacity: 0;
  }

  .imgBox {
    position: relative;
    width: 100vw;
    height: calc(100vh - 0.48rem);

    .swp_img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      max-width: 100vw;
      max-height: 100vh;
      width: auto;
      height: auto;
    }
  }
}

.backbar {
  .del {
    float: right;
    width: 0.2rem;
    height: 0.2rem;

    img {
      display: block;
    }
  }
}

@keyframes roll {
  from {
    transform: rotateZ(0);
  }
  to {
    transform: rotateZ(360deg);
  }
}
</style>
